import dayjs from 'dayjs';
import type { Dayjs, OptionType } from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import timezone from 'dayjs/plugin/timezone';
import utc from 'dayjs/plugin/utc';

import type { Time } from '@jane/shared/types';

import { parseApiTimezones } from '../timezones/parseApiTimezones';

dayjs.extend(advancedFormat);
dayjs.extend(timezone);
dayjs.extend(utc);
dayjs.extend(customParseFormat);

export const parseTime = (
  time: Time | number,
  timezone: string,
  format?: OptionType
): Dayjs =>
  typeof time === 'number' && time.toString().length === 10
    ? dayjs.unix(time).tz(parseApiTimezones(timezone))
    : dayjs(time, format).tz(parseApiTimezones(timezone));

export const parseCurrentTime = (timezone: string): Dayjs =>
  dayjs().tz(parseApiTimezones(timezone));
